import { render, staticRenderFns } from "./MainMenuWide.vue?vue&type=template&id=bf091302&scoped=true"
import script from "./MainMenuWide.vue?vue&type=script&lang=js"
export * from "./MainMenuWide.vue?vue&type=script&lang=js"
import style0 from "./MainMenuWide.vue?vue&type=style&index=0&id=bf091302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf091302",
  null
  
)

export default component.exports